import { render } from "./ConfirmProfile.vue?vue&type=template&id=6f4b6353"
import script from "./ConfirmProfile.vue?vue&type=script&lang=js"
export * from "./ConfirmProfile.vue?vue&type=script&lang=js"

import "./ConfirmProfile.vue?vue&type=style&index=0&id=6f4b6353&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__